export default __webpack_public_path__ + "static/media/019-receipt.d893f5a3.svg";